import React from 'react';
import {Input} from '@components';
import {useTranslation} from 'react-i18next';
import {useFormikContext} from 'formik';
import {WhiteButton} from '@styled';

const NewComment = ({isActive}) => {
  const [t] = useTranslation();
  const values = useFormikContext();
  const [isLoaded, setLoaded] = React.useState(false);
  React.useEffect(() => {
    if (isActive && !isLoaded) {
      setLoaded(true);
    }
  }, [isActive, isLoaded]);
  return isLoaded ? (
    <div>
      <Input
        as="textarea"
        name="comments"
        id="comments"
        label={t('owner.validators.reports.review.comments')}
        placeholder=""
        rows={10}
        required={
          values.status && values.status.value === 'Rejected' ? true : false
        }
      />
      <WhiteButton>
        {t('owner.validators.reports.review.attachReport')}
      </WhiteButton>
    </div>
  ) : null;
};

export default NewComment;
